import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import InstaServiceProductionCategory from './InstaServiceProductionCategory';

const base = 'cooking-v2';

@inject('ProductionStore')
@observer
class InstaServiceProduction extends Component {
    render() {
        const { instaServiceProductions } = this.props;

        const groupedByLocation = instaServiceProductions.reduce((acc, stock) => {
            stock.requests.forEach((request) => {
                if (request.status === 'COMPLETED') {
                    return;
                }

                const rawLocation = (request.insta_service_location || 'Warmer').trim();
                const normalizedLocation = rawLocation
                    .toLowerCase()
                    .replace(/\s+/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());

                if (!acc[normalizedLocation]) {
                    acc[normalizedLocation] = [];
                }

                acc[normalizedLocation].push({
                    ...request,
                    id: stock.id,
                    created_date: stock.created_date,
                });
            });

            return acc;
        }, {});

        const allLocations = Object.keys(groupedByLocation);
        const fixedOrder = ['Warmer', 'Sous Vide', 'Chiller'];
        const otherLocations = allLocations.filter((location) => !fixedOrder.includes(location));
        const locations = [...fixedOrder, ...otherLocations.sort()];

        const groupedData = locations.map((location) => {
            const requests = groupedByLocation[location] || [];
            const groupedByCategory = requests.reduce((acc, request) => {
                const { category } = request;

                if (!acc[category]) {
                    acc[category] = {
                        id: request.id,
                        items: [],
                        created_date: request.created_date,
                    };
                }

                acc[category].items.push(request);

                if (new Date(request.created_date) < new Date(acc[category].created_date)) {
                    acc[category].created_date = request.created_date;
                }

                return acc;
            }, {});

            const categories = Object.keys(groupedByCategory)
                .map((category) => ({
                    id: groupedByCategory[category].id,
                    category,
                    created_date: groupedByCategory[category].created_date,
                    items: groupedByCategory[category].items.sort((a, b) => b.quantity - a.quantity),
                }))
                .sort((a, b) => b.items.length - a.items.length);

            return { location, categories };
        });

        const hasPendingTopUp = groupedData.some(({ categories }) => categories.length > 0);

        return (
            <div>
                <div
                    className={`${base}__card_header top-up`}
                >
                    <div
                        className='top-up'
                    >
                        TOPUP NOW
                    </div>
                </div>
                <div className={`${base}__insta_service_panel_body`}>
                    {groupedData.map(({ location, categories }) => {
                        if (categories.length === 0) {
                            return null;
                        }

                        const locationKey = location.toLowerCase().replace(/\s+/g, '-');

                        return (
                            <div
                                key={location}
                                className={`${base}__insta_service_location_section ${base}__insta_service_location_section_pending ${base}__insta_service_location_section_pending--${locationKey}`}
                            >
                                <h4 className={`${base}__insta_service_location_title ${base}__insta_service_location_title--${locationKey}`}>
                                    {`IN ${location.toUpperCase()}`}
                                </h4>
                                {categories.map((category) => (
                                    <InstaServiceProductionCategory
                                        category={category}
                                        chunkSize={1}
                                        key={`${location}-${category.category}`}
                                        isCurrentStock={false}
                                    />
                                ))}
                            </div>
                        );
                    })}
                    {!hasPendingTopUp && (
                        <p className={`${base}__insta_service_empty_state`}>
                            No pending top ups
                        </p>
                    )}
                </div>
            </div>
        );
    }
}

export default InstaServiceProduction;
